import React, {Component} from 'react';
import NotificationsSystem from 'reapop';
import {theme} from './theme';

export class KareNotificationsSystem extends Component {
    render() {
        return <NotificationsSystem theme={theme} />;
    }
}
